import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Bell } from 'lucide-react';

export function UserNotificationsDialog({ open, onOpenChange, notifications }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="!bg-white max-w-md max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-slate-900 flex items-center gap-2">
            <Bell className="h-5 w-5" /> Notificações
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 mt-4">
          {notifications.length === 0 ? (
            <p className="text-slate-500 text-center py-6">Nenhuma notificação</p>
          ) : (
            notifications.map(n => (
              <div key={n.notification_id} className={`p-3 rounded-md border ${n.read ? 'bg-white border-slate-200' : 'bg-blue-50 border-blue-200'}`} data-testid={`notif-${n.notification_id}`}>
                <p className="font-semibold text-slate-900 text-sm">{n.title}</p>
                <p className="text-xs text-slate-600 mt-1">{n.message}</p>
                <p className="text-xs text-slate-400 mt-1">{new Date(n.created_at).toLocaleDateString('pt-BR')}</p>
              </div>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
